var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCUserEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.333 1.714c.083-.544.55-.946 1.1-.946h19.505c.615 0 1.113.498 1.113 1.113v8.946c0 .615-.498 1.114-1.113 1.114H9.072A1.113 1.113 0 017.97 10.66l1.362-8.946z",
    fill: "url(#cUser_en_svg__paint0_linear_12483_62914)",
    stroke: "url(#cUser_en_svg__paint1_linear_12483_62914)",
    strokeWidth: 0.414
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.504 3.265h.879l1.512 4.41h.022l1.505-4.41h.879l-1.907 5.319h-.983l-1.907-5.319zm5.372 0h.805v5.319h-.805V3.265zm1.862 0h2.205c1.266 0 1.9.537 1.9 1.617 0 1.087-.641 1.63-1.915 1.63H25.55v2.072h-.812V3.265zm.812.693V5.82h1.326c.402 0 .692-.074.879-.223.178-.15.275-.388.275-.715 0-.328-.097-.566-.283-.7-.186-.15-.476-.224-.871-.224H25.55z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18 11.797a.828.828 0 001.193 0l5.964-6.203a.828.828 0 00.079-1.052L11.86.932a.827.827 0 00-.675-.35H4.369c-.269 0-.52.131-.676.35l-2.555 3.61a.828.828 0 00.078 1.052l5.964 6.203z",
    fill: "#2C0309"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.661 2.486a2.782 2.782 0 00-2.073 4.638c.108.12.216.228.335.324.48.383 1.079.61 1.738.61.66 0 1.258-.227 1.738-.61a2.225 2.225 0 00-.348-.324 2.31 2.31 0 01-1.39.467 2.337 2.337 0 01-1.738-.79 5.525 5.525 0 01-.215-.276c-.24-.36-.372-.791-.372-1.259a2.327 2.327 0 012.325-2.324 2.327 2.327 0 012.325 2.324c0 .468-.144.9-.372 1.259.12.096.24.203.348.323a2.75 2.75 0 00.491-1.582 2.8 2.8 0 00-2.792-2.78z",
    fill: "#FFD3DA",
    stroke: "#FFD3DA",
    strokeWidth: 0.248
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.735 7.148a2.957 2.957 0 00-.336-.336 2.804 2.804 0 00-.85-.467 2.698 2.698 0 00-.887-.144.923.923 0 11.922-.923c0 .252-.096.48-.263.648.167.035.323.083.48.143a1.41 1.41 0 00.25-.79c0-.768-.622-1.39-1.39-1.39a1.38 1.38 0 00-1.39 1.377c0 .3.096.576.252.791.072.108.156.192.252.276.24.204.551.324.887.324.515 0 .994.18 1.39.467.132.096.24.228.347.347.156.18.288.408.384.636h.503a3.178 3.178 0 00-.551-.96z",
    fill: "url(#cUser_en_svg__paint2_linear_12483_62914)",
    stroke: "url(#cUser_en_svg__paint3_linear_12483_62914)",
    strokeWidth: 0.248
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cUser_en_svg__paint0_linear_12483_62914",
    x1: 32.116,
    y1: 0.49,
    x2: 7.199,
    y2: 3.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB7C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#AD0C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCDD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cUser_en_svg__paint1_linear_12483_62914",
    x1: 32.617,
    y1: 6.283,
    x2: 9.04,
    y2: 6.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD0C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FFE9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD0C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cUser_en_svg__paint2_linear_12483_62914",
    x1: 10.129,
    y1: 3.862,
    x2: 6.178,
    y2: 4.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB7C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#AD0C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCDD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cUser_en_svg__paint3_linear_12483_62914",
    x1: 10.129,
    y1: 3.862,
    x2: 6.178,
    y2: 4.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB7C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#AD0C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCDD5"
  })))));
}
export default SvgCUserEn;